// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   baseUrl: 'https://brokerdevapi.nemtbusiness.com/',
  TRACKING_URL: "https://routedev.nemtbusiness.com/",
  SQUARE_APPLICATION_ID:"sandbox-sq0idb-cBJJwzeVdqqFD61eKPC7Sg",
  SQUARE_LOCATION_ID:"L3C45WED6S7QK",
  SQUARE_DEVELOPER_URL:"https://sandbox.web.squarecdn.com/v1/square.js",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
